import { HttpClient } from '../HttpClient';
/**
 * * Get List of Employees
 */
export const GetEmployees = async ({
  PageNumber = 1,
  RowsPerPage = 10,
  CompanyId,
  Fullname,
  SortColumn = 'lastName',
  Include,
  DepartmentId,
  LocationId,
}) => {
  try {
    const { data } = await HttpClient.get('/api/employees', {
      params: {
        CompanyId,
        ...(Fullname ? { Fullname: Fullname } : {}),
        PageNumber,
        RowsPerPage,
        SortColumn,
        Include,
        DepartmentId,
        LocationId,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
